import { Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { obtenerDatosConjunto } from "../../functions/consultas";
import { auth } from "../../functions/api_firebase";
import { signOut } from "firebase/auth";
import "../css/barra_superior.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { CORREO_MONITOREO, CORREO_SISTEMAS, normalizarCorreo } from "./sos/acceso_sos";


const R = {
  SUPER:         "SUPER",
  ADMINISTRADOR: "ADMINISTRADOR",
  GUARDA:        "GUARDA",
  RESIDENTE:     "RESIDENTE",
  AUDITOR:       "AUDITOR",
  CONTADOR:      "CONTADOR",
};

const NIT_TICKETS = "900362633";

const ICONOS = {
  INICIO:         "bi-house",
  SOS:            "bi-exclamation-triangle",
  GPS:            "bi-map",
  RONDAS:         "bi-arrow-repeat",
  CARTERA:        "bi-wallet2",
  PAGOS:          "bi-credit-card",
  OPERACIÓN:      "bi-gear",
  ADMINISTRACIÓN: "bi-building",
  SOPORTE:        "bi-headset",
  INFORMES:       "bi-bar-chart",
  TUTORIALES:     "bi-play-circle",
  LEGAL:          "bi-shield-check",
  INMUEBLES:      "bi-buildings",
};


const MENU = [
  {
    nombre: "INICIO",
    siempreVisible: true,
    rutas: [{ ruta: "/inicio", roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE, R.AUDITOR, R.CONTADOR] }],
  },
  {
    nombre: "OPERACIÓN",
    rutas: [
      { ruta: "/visitantes",   etiqueta: "Visitantes",  icono: "bi-people",         roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE] },
      { ruta: "/encomiendas",  etiqueta: "Encomiendas", icono: "bi-box-seam",        roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE] },
      { ruta: "/pqrs",         etiqueta: "PQRS",        icono: "bi-chat-left-text",  roles: [R.SUPER, R.ADMINISTRADOR, R.RESIDENTE] },
      { ruta: "/anuncios",     etiqueta: "Anuncios",    icono: "bi-megaphone",       roles: [R.SUPER, R.ADMINISTRADOR, R.RESIDENTE] },
      { ruta: "/novedades",    etiqueta: "Novedades",   icono: "bi-clipboard",       roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA] },
      { ruta: "/rondas",       etiqueta: "Rondas",      icono: "bi-arrow-repeat",    roles: [R.SUPER, R.ADMINISTRADOR, R.AUDITOR] },
      { ruta: "/gps",          etiqueta: "GPS",         icono: "bi-map",             roles: [R.SUPER, R.ADMINISTRADOR] },
      { ruta: "/crear_reserva",etiqueta: "Reservas",    icono: "bi-calendar-check",  roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE] },
      { ruta: "/mi_propiedad", etiqueta: "Mi Propiedad",icono: "bi-house-heart",     roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE] },
    ],
  },
  {
    nombre: "ADMINISTRACIÓN",
    rutas: [
      { ruta: "/noticias",            etiqueta: "Noticias",           icono: "bi-newspaper",   roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE, R.AUDITOR] },
      { ruta: "/notificaciones",      etiqueta: "Notificaciones",     icono: "bi-bell",        roles: [R.SUPER, R.ADMINISTRADOR, R.RESIDENTE] },
      { ruta: "/mi_cartera",          etiqueta: "Pagos",              icono: "bi-credit-card", roles: [R.RESIDENTE, R.ADMINISTRADOR, R.SUPER] },
      { ruta: "/usuarios",            etiqueta: "Usuarios",           icono: "bi-person",      roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA] },
      { ruta: "/cartera",             etiqueta: "Cartera",            icono: "bi-wallet2",     roles: [R.SUPER, R.ADMINISTRADOR] },
      { ruta: "/reservas",            etiqueta: "Reservas",           icono: "bi-calendar",    roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA] },
      { ruta: "/zonas_sociales",      etiqueta: "Zonas Sociales",     icono: "bi-door-open",   roles: [R.SUPER, R.ADMINISTRADOR] },
      { ruta: "/censo",               etiqueta: "Censo",              icono: "bi-list-ol",     roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA] },
      { ruta: "/documentos",          etiqueta: "Documentos",         icono: "bi-file-earmark-text", roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE] },
      { ruta: "/chats",               etiqueta: "Chats",              icono: "bi-chat-dots",   roles: [R.SUPER, R.ADMINISTRADOR, R.RESIDENTE] },
      { ruta: "/perfil_copropiedad",  etiqueta: "Perfil copropiedad", icono: "bi-building",    roles: [R.SUPER, R.ADMINISTRADOR] },
      { ruta: "/cobro_parqueaderos",  etiqueta: "Cobro parqueaderos", icono: "bi-p-square",    roles: [R.SUPER, R.ADMINISTRADOR], modulo: "moduloParqueadero" },
      { ruta: "/configuracion_modulos",etiqueta: "Módulos",           icono: "bi-toggles",     roles: [R.SUPER, R.ADMINISTRADOR] },
    ],
  },
  {
    nombre: "SOPORTE",
    rutas: [
      { ruta: "/tickets",            etiqueta: "Tickets",          icono: "bi-ticket-perforated", roles: [R.SUPER], nitRequerido: NIT_TICKETS },
      { ruta: "/tickets_categorias", etiqueta: "Categorías Tickets", icono: "bi-tags",            roles: [R.SUPER], nitRequerido: NIT_TICKETS },
      { ruta: "/tickets_usuarios",   etiqueta: "Usuarios Tickets", icono: "bi-people",            roles: [R.SUPER], nitRequerido: NIT_TICKETS },
      { ruta: "/clientes",           etiqueta: "Clientes",         icono: "bi-briefcase",         roles: [R.SUPER] },
      { ruta: "/logs",               etiqueta: "Logs",             icono: "bi-file-text",         roles: [R.SUPER] },
      { ruta: "/correos_excluidos",  etiqueta: "Correos Excluidos", icono: "bi-envelope-slash",   roles: [R.SUPER] },
      { ruta: "/inmuebles_administrativos", etiqueta: "Inmuebles Administrativos", icono: "bi-building-gear", roles: [R.SUPER] },
      { ruta: "/configuraciones_globales", etiqueta: "Config. Globales", icono: "bi-sliders",     roles: [R.SUPER] },
      { ruta: "/cuenta_correo",      etiqueta: "Cuenta de correo",  icono: "bi-envelope-at",       roles: [R.SUPER] },
      { ruta: "/fiesta",             etiqueta: "Safari con Coordinar", icono: "bi-balloon",       roles: [R.SUPER] },
    ],
  },
  {
    nombre: "INFORMES",
    rutas: [
      { ruta: "/estadistica",        etiqueta: "Estadística Módulos",  icono: "bi-graph-up",            roles: [R.SUPER, R.ADMINISTRADOR] },
      { ruta: "/informe_censo",      etiqueta: "Informe Censo",        icono: "bi-file-earmark-bar-graph",roles: [R.SUPER, R.ADMINISTRADOR] },
      { ruta: "/estadistica_censo",  etiqueta: "Estadística Censo",    icono: "bi-pie-chart",           roles: [R.SUPER, R.ADMINISTRADOR] },
      { ruta: "/seguimiento",        etiqueta: "Métricas Usuarios",    icono: "bi-graph-down",          roles: [R.SUPER, R.ADMINISTRADOR] },
      { ruta: "/rating",             etiqueta: "Calificaciones",       icono: "bi-star",                roles: [R.SUPER] },
      { ruta: "/logs_grafica",       etiqueta: "Informe uso CoordiPH", icono: "bi-bar-chart-line",      roles: [R.SUPER] },
      { ruta: "/unidades_vivienda",  etiqueta: "Unidades de Vivienda", icono: "bi-house-door",          roles: [R.SUPER] },
      { ruta: "/estadistica_fiesta", etiqueta: "Informe Safari",       icono: "bi-balloon",             roles: [R.SUPER] },
      { ruta: "/estadistica_tickets", etiqueta: "Estadística Tickets", icono: "bi-ticket-perforated",   roles: [R.SUPER, R.ADMINISTRADOR], nitRequerido: NIT_TICKETS },
    ],
  },
  {
    nombre: "TUTORIALES",
    siempreVisible: true,
    rutas: [{ ruta: "/tutoriales", roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE] }],
  },
  {
    nombre: "LEGAL",
    siempreVisible: true,
    rutas: [{ ruta: "/legal", roles: [R.SUPER, R.ADMINISTRADOR, R.GUARDA, R.RESIDENTE] }],
  },
  {
    nombre: "INMUEBLES",
    siempreVisible: true,
    rutas: [{ ruta: "/inmuebles", roles: [R.SUPER, R.ADMINISTRADOR, R.RESIDENTE, R.GUARDA, R.AUDITOR] }],
  },
];

const MENU_COMUN_FINAL = [
  { nombre: "TUTORIALES", siempreVisible: true, rutas: [{ ruta: "/tutoriales" }] },
  { nombre: "LEGAL",      siempreVisible: true, rutas: [{ ruta: "/legal"      }] },
  { nombre: "INMUEBLES",  siempreVisible: true, rutas: [{ ruta: "/inmuebles"  }] },
];

const INICIO = { nombre: "INICIO", siempreVisible: true, rutas: [{ ruta: "/inicio" }] };


const MENU_MONITOREO = [
  INICIO,
  { nombre: "SOS",     siempreVisible: true, rutas: [{ ruta: "/sos" }] },
  ...MENU_COMUN_FINAL,
];

const MENU_AUDITOR = [
  INICIO,
  { nombre: "GPS",     siempreVisible: true, rutas: [{ ruta: "/gps" }] },
  { nombre: "RONDAS",  siempreVisible: true, rutas: [{ ruta: "/rondas" }] },
  ...MENU_COMUN_FINAL,
];

const MENU_CONTADOR = [
  INICIO,
  { nombre: "CARTERA", siempreVisible: true, rutas: [{ ruta: "/cartera"    }] },
  { nombre: "PAGOS",   siempreVisible: true, rutas: [{ ruta: "/mi_cartera" }] },
  ...MENU_COMUN_FINAL,
];


const filtrarMenu = ({ correo, permisos, nit, conjunto }) => {
  const correoNormalizado = normalizarCorreo(correo);

  if (correoNormalizado === CORREO_MONITOREO) return MENU_MONITOREO;
  if (permisos === R.AUDITOR)  return MENU_AUDITOR;
  if (permisos === R.CONTADOR) return MENU_CONTADOR;

  const menuConSOS = correoNormalizado === CORREO_SISTEMAS
    ? MENU.map(cat => cat.nombre !== "OPERACIÓN" ? cat : {
        ...cat,
        rutas: [...cat.rutas, { ruta: "/sos", etiqueta: "SOS", icono: "bi-exclamation-triangle", roles: [R.SUPER, R.ADMINISTRADOR] }]
      })
    : MENU;

  return menuConSOS
    .map(cat => ({
      ...cat,
      rutas: cat.rutas.filter(({ roles, nitRequerido, modulo }) => {
        // Módulo deshabilitado en "Módulos" del conjunto.
        if (modulo && conjunto[modulo] === false) return false;
        if (!roles) return true;
        const tieneRol = roles.includes(permisos);
        return nitRequerido ? tieneRol && nit === nitRequerido : tieneRol;
      })
    }))
    .filter(cat => cat.rutas.length > 0 && (cat.siempreVisible || cat.rutas.length > 1));
};


const ItemDirecto = ({ ruta, icono, etiqueta, onCerrar }) => (
  <div className="sidebarSeccion">
    <Link className="sidebarItem" to={ruta} onClick={onCerrar}>
      <i className={`bi ${icono} sidebarIcono`} />
      {etiqueta}
    </Link>
  </div>
);

const ItemDropdown = ({ categoria, estaAbierto, onToggle, onCerrar }) => {
  const icono = ICONOS[categoria.nombre] || "bi-circle";
  return (
    <div className="sidebarSeccion">
      <button className="sidebarToggle" onClick={onToggle} aria-expanded={estaAbierto}>
        <span className="sidebarToggleLeft">
          <i className={`bi ${icono} sidebarIcono`} />
          {categoria.nombre}
        </span>
        <i className={`bi bi-chevron-down sidebarChevron ${estaAbierto ? "rotado" : ""}`} />
      </button>
      {estaAbierto && (
        <ul className="sidebarSubMenu">
          {categoria.rutas.map(({ ruta, etiqueta, icono: ic }) => (
            <li key={ruta}>
              <Link to={ruta} onClick={onCerrar}>
                <i className={`bi ${ic} sidebarIcono`} />
                {etiqueta}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const NavCategoria = ({ categoria, dropdownAbierto, onToggle, onCerrar, plano }) => {
  const icono = ICONOS[categoria.nombre] || "bi-circle";
  const rutaUnica = categoria.rutas.length === 1;

  if (plano) {
    if (rutaUnica && !categoria.rutas[0].etiqueta) {
      return (
        <ItemDirecto
          key={categoria.rutas[0].ruta}
          ruta={categoria.rutas[0].ruta}
          icono={icono}
          etiqueta={categoria.nombre}
          onCerrar={onCerrar}
        />
      );
    }
    return categoria.rutas.map(({ ruta, etiqueta, icono: ic }) => (
      <ItemDirecto key={ruta} ruta={ruta} icono={ic} etiqueta={etiqueta} onCerrar={onCerrar} />
    ));
  }

  if (rutaUnica) {
    return (
      <ItemDirecto
        ruta={categoria.rutas[0].ruta}
        icono={icono}
        etiqueta={categoria.nombre}
        onCerrar={onCerrar}
      />
    );
  }

  return (
    <ItemDropdown
      categoria={categoria}
      estaAbierto={dropdownAbierto === categoria.nombre}
      onToggle={() => onToggle(categoria.nombre)}
      onCerrar={onCerrar}
    />
  );
};


const BarraSuperior = () => {
  const [sidebarAbierto, setSidebarAbierto] = useState(false);
  const [dropdownAbierto, setDropdownAbierto] = useState(null);

  const userData = useMemo(() => ({
    nombres:   localStorage.getItem("NombreCompleto")    || "",
    direccion: localStorage.getItem("Direccion")         || "",
    permisos:  localStorage.getItem("Permisos")          || "",
    cliente:   localStorage.getItem("RazonSocial")       || "",
    nit:       localStorage.getItem("CodigoCliente")     || "",
    correo:    localStorage.getItem("CorreoElectronico") || "",
  }), []);

  const { nombres, direccion, permisos, cliente, nit, correo } = userData;

  const [conjunto, setConjunto] = useState({});
  useEffect(() => {
    let activo = true;
    obtenerDatosConjunto().then((datos) => activo && setConjunto(datos || {}));
    return () => { activo = false; };
  }, []);

  const categoriasFiltradas = useMemo(
    () => filtrarMenu({ correo, permisos, nit, conjunto }),
    [correo, permisos, nit, conjunto]
  );

  const cerrarSesion = async () => {
    try {
      await signOut(auth);
      localStorage.clear();
      sessionStorage.removeItem("InmuebleSeleccionado");
      window.location.replace("/");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const cerrarSidebar = () => {
    setSidebarAbierto(false);
    setDropdownAbierto(null);
  };

  const toggleDropdown = (nombre) =>
    setDropdownAbierto(prev => prev === nombre ? null : nombre);

  const esPlano = permisos === R.RESIDENTE;

  const infoUsuario = [
    { label: "Nombre",      valor: nombres },
    { label: "Dirección",   valor: direccion },
    { label: "Permisos",    valor: permisos },
    { label: "Razón Social",valor: cliente },
    { label: "NIT",         valor: nit },
  ];

  return (
    <>
      <div className="barraSuperior">
        <button className="barraBotonMenu" onClick={() => setSidebarAbierto(true)} aria-label="Abrir menú">
          <i className="bi bi-list" />
        </button>
        <span className="barraTitulo">CoordiPH</span>
        <span style={{ width: 40 }} />
      </div>

      <div className={`sidebarOverlay ${sidebarAbierto ? "visible" : ""}`} onClick={cerrarSidebar} />

      <aside className={`sidebar ${sidebarAbierto ? "abierto" : ""}`}>
        <div className="sidebarHeader">
          <span className="sidebarHeaderTitulo">Menú</span>
          <button className="sidebarCerrarBtn" onClick={cerrarSidebar} aria-label="Cerrar menú">
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <div className="sidebarInfoUsuario">
          {infoUsuario.map(({ label, valor }) => (
            <p key={label}><strong>{label}:</strong> {valor}</p>
          ))}
        </div>

        <nav className="sidebarNav" role="navigation" aria-label="Navegación principal">
          {categoriasFiltradas.map(categoria => (
            <NavCategoria
              key={categoria.nombre}
              categoria={categoria}
              dropdownAbierto={dropdownAbierto}
              onToggle={toggleDropdown}
              onCerrar={cerrarSidebar}
              plano={esPlano}
            />
          ))}
        </nav>

        <div className="sidebarFooter">
          <button className="sidebarCerrarSesion" onClick={cerrarSesion}>
            <i className="bi bi-box-arrow-left sidebarIcono" />
            Cerrar sesión
          </button>
        </div>
      </aside>
    </>
  );
};

export default BarraSuperior;
